__turbopack_context__.v({
  "button": "Button-module-scss-module__W4cObW__button",
  "button--isMenu": "Button-module-scss-module__W4cObW__button--isMenu",
  "default": "Button-module-scss-module__W4cObW__default",
  "link": "Button-module-scss-module__W4cObW__link",
  "narrow": "Button-module-scss-module__W4cObW__narrow",
});
